import { AxiosError } from 'axios';

import { PILLAR_ACTIVE_LIMIT, PILLAR_ACTIVE_LIMIT_ERROR_CODE } from '@/constants/PillarStatus';
import i18n from '@/plugins/i18n';
import { showErrorToast } from '@/plugins/Toast';

/**
 * The pillar creation/update/activation endpoints return a 409 with `{ error, code }` once the
 * company already has `PILLAR_ACTIVE_LIMIT` active pillars. `error` carries the backend's own
 * (untranslated) message, so the FE keys off `code` instead of the generic `useError` message
 * lookup to show its own localized wording.
 */
export const isPillarActiveLimitError = (error: unknown): boolean => {
    if (!(error instanceof AxiosError)) {
        return false;
    }

    const responseData = error.response?.data as { code?: string } | undefined;
    return error.response?.status === 409 && responseData?.code === PILLAR_ACTIVE_LIMIT_ERROR_CODE;
};

export const showPillarActiveLimitToast = () => {
    showErrorToast({
        message: i18n.t('pillars.errors.activeLimitReached', { max: PILLAR_ACTIVE_LIMIT }),
    });
};
